<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container" id="bgCustom">
      <div class="bg-white login-box">
        <div class="top">
        <div class="header">
          <a href="/">
            <img src="@/assets/logo.png" class="logo" alt="logo">
             <!-- <img :src="ainformation.indexPage" class="logo" alt="logo"> -->
            <span class="title">{{ ainformation.pageName }}</span>
          </a>
        </div>
        <div class="desc">

        </div>
      </div>

      <router-view />
    </div>

  </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'
import {getConfigKey} from '@/api/system/config'
import {mapGetters} from 'vuex'
export default {
  name: 'UserLayout',
  data(){
    return{
      title:process.env.VUE_APP_TITLE
    }   
  },
  mixins: [deviceMixin],
  mounted () {
    document.body.classList.add('userLayout')
  },
  computed: {
    ...mapGetters(['ainformation'])
  },
  created () {
    this.getBackgroundImg();
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  },
  methods: {
    getBackgroundImg() {
      getConfigKey('system.background.img').then(response => {
        // 获取HTML元素
        var element = document.getElementById('bgCustom');
        element.style.background = '#f0f2f5 url(' + response.data + ')';
      })
    },
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background-size: 100%;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .85);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
  .login-box{
    width: 500px;
    margin: 0 auto;
    padding: 20px 0;
    border-radius: 16px;
  }
</style>
